// A native scroll track supports touch swipes even before JavaScript loads.
document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
  const track = gallery.querySelector('[data-gallery-track]');
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const previous = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  const status = gallery.querySelector('[data-gallery-status]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  if (slides.length < 2) return;
  let index = 0, targetIndex = 0, timer;
  const update = () => {
    index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    targetIndex = index;
    thumbs.forEach((thumb, i) => i === index ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
    previous.disabled = index === 0;
    next.disabled = index === slides.length - 1;
    const label = `${index + 1} / ${slides.length}`;
    if (status.textContent !== label) status.textContent = label;
    slides.forEach((slide, i) => { if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause()); });
  };
  const show = value => {
    targetIndex = Math.max(0, Math.min(slides.length - 1, value));
    track.scrollTo({left: targetIndex * track.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
  };
  previous.addEventListener('click', () => show(targetIndex - 1));
  next.addEventListener('click', () => show(targetIndex + 1));
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
  track.addEventListener('keydown', event => {
    if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    if (event.key === 'Home' || event.key === 'End') show(event.key === 'Home' ? 0 : slides.length - 1);
    else show(targetIndex + (event.key === 'ArrowLeft' ? -1 : 1));
  });
  track.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(update, 120); }, {passive:true});
  new ResizeObserver(() => { track.scrollTo({left:index * track.clientWidth, behavior:'instant'}); update(); }).observe(track);
  gallery.querySelectorAll('[data-gallery-controls]').forEach(control => { control.hidden = false; });
  update();
});
document.querySelectorAll('[data-scroll]').forEach(button => button.addEventListener('click', () => { const track = document.getElementById(button.dataset.track); if (track) track.scrollBy({left: Number(button.dataset.scroll) * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); }));
document.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
document.addEventListener('keydown', event => { if(event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu=>menu.removeAttribute('open')); });
const variantSelect = document.querySelector('[data-variant-select]');
if(variantSelect) variantSelect.addEventListener('change', () => { const option=variantSelect.selectedOptions[0]; const price=document.querySelector('[data-product-price]'); const submit=document.querySelector('[data-add-to-cart]'); if(price) price.textContent=option.dataset.price; if(submit){submit.disabled=option.dataset.available!=='true';submit.textContent=submit.disabled?'Sold out':'Add to basket';} const url=new URL(location.href);url.searchParams.set('variant',variantSelect.value);history.replaceState({},'',url); });

// Example catalog has no inventory or checkout side effects.
const demoDataElement=document.getElementById('demo-product-data');
if(demoDataElement){
  const demoProducts=JSON.parse(demoDataElement.textContent);
  const dialog=document.getElementById('demo-dialog');
  let lastDemoTrigger;
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-demo-open]');
    if(!trigger)return;
    const product=demoProducts.find(p=>p.id===trigger.dataset.demoOpen);
    if(!product)return;
    lastDemoTrigger=trigger;
    dialog.querySelector('#demo-title').textContent=product.name;
    dialog.querySelector('[data-demo-subtitle]').textContent=product.subtitle;
    dialog.querySelector('[data-demo-format]').textContent=product.format+' · Example format';
    dialog.querySelector('[data-demo-price]').textContent=new Intl.NumberFormat('en-GB',{style:'currency',currency:'EUR'}).format(product.price);
    dialog.querySelector('[data-demo-description]').textContent=product.description;
    const image=dialog.querySelector('[data-demo-image]');image.src=product.image;image.alt='BYBV example packaging: '+product.name;
    dialog.showModal();document.body.classList.add('demo-dialog-open');
  });
  dialog.querySelector('[data-demo-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{document.body.classList.remove('demo-dialog-open');lastDemoTrigger?.focus();});
}
const normalizeDemoText=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
document.querySelectorAll('[data-demo-search]').forEach(form=>{
  const input=form.querySelector('[name="q"]');
  const scope=form.closest('section');
  const filter=()=>{
    const query=normalizeDemoText(input.value.trim());let count=0;
    scope.querySelectorAll('[data-demo-card]').forEach(card=>{const match=normalizeDemoText(card.dataset.name).includes(query);card.hidden=!match;if(match)count++;});
    scope.querySelectorAll('[data-demo-category]').forEach(category=>{category.hidden=![...category.querySelectorAll('[data-demo-card]')].some(card=>!card.hidden);});
    const status=scope.querySelector('#demo-search-status');status.hidden=!query;status.textContent=count?`${count} ${count===1?'example product found':'example products found'}.`:'No example products match your search.';
  };
  input.addEventListener('input',filter);
  form.addEventListener('submit',event=>{event.preventDefault();filter();});
  if(input.hasAttribute('data-demo-query')){input.value=new URLSearchParams(location.search).get('q')||'';filter();}
});
document.querySelectorAll('.bybv-short video').forEach(video=>video.addEventListener('play',()=>{document.querySelectorAll('.bybv-short video').forEach(other=>{if(other!==video)other.pause();});}));

// Native scrolling keeps touch gestures and video controls independent.
document.querySelectorAll('[data-video-carousel]').forEach(carousel => {
  const track = carousel.querySelector('[data-video-track]');
  const cards = [...track.querySelectorAll('.bybv-short')];
  const previous = carousel.querySelector('[data-video-prev]');
  const next = carousel.querySelector('[data-video-next]');
  const status = carousel.querySelector('[data-video-status]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  if (!cards.length) return;
  const step = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    previous.disabled = track.scrollLeft <= 3;
    next.disabled = track.scrollLeft >= max - 2;
    const bounds = track.getBoundingClientRect();
    const visible = cards.map((card, i) => ({i, r:card.getBoundingClientRect()})).filter(({r}) => r.left < bounds.right - r.width * .5 && r.right > bounds.left + r.width * .5);
    if (visible.length) {
      const first = visible[0].i + 1, last = visible[visible.length - 1].i + 1;
      const text = `${first === last ? first : `${first}–${last}`} of ${cards.length}`;
      if(status.textContent !== text) status.textContent = text;
    }
  };
  const move = direction => track.scrollBy({left: direction * step(), behavior:reducedMotion.matches ? 'instant' : 'smooth'});
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('keydown', event => {
    if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    if(event.key === 'ArrowLeft' || event.key === 'ArrowRight') move(event.key === 'ArrowLeft' ? -1 : 1);
    else track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth, behavior:reducedMotion.matches ? 'instant' : 'smooth'});
  });
  let timer;
  track.addEventListener('scroll', () => {clearTimeout(timer); timer = setTimeout(update, 120);}, {passive:true});
  new ResizeObserver(update).observe(track);
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) entry.target.pause();
  }), {root:track, threshold:0});
  track.querySelectorAll('video').forEach(video => observer.observe(video));
  document.addEventListener('visibilitychange', () => {if(document.hidden) track.querySelectorAll('video').forEach(video => video.pause());});
  update();
});
